import { render, staticRenderFns } from "./CmgPersonalAndPreferencesPage.vue?vue&type=template&id=43aae89b&scoped=true&lang=pug&"
import script from "./cmg-personal-and-preferences-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-personal-and-preferences-page.ts?vue&type=script&lang=ts&"
import style0 from "./CmgPersonalAndPreferencesPage.vue?vue&type=style&index=0&id=43aae89b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43aae89b",
  null
  
)

export default component.exports